import * as React from 'react';
import { Button, Column, DataTable } from 'primereact';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { TabView, TabPanel } from 'primereact/tabview';
import axios from 'axios';
import URLUtils, { getAppNameFromPath } from '../utilities/URLUtils';
import SessionStorageService from '../services/SessionStorageService';
import { SpinnerComponent } from '../commonComponent/SpinnerComponent';
import { parseJson } from '../utilities/JsonUtils';
import { TOKEN_TYPE } from '../entities/Constants';
import { getEnvVar } from '../config/RuntimeConfig';

const ENVIRONMENT = (getEnvVar('ENVIRONMENT') ?? getEnvVar('NODE_ENV') ?? '').toLowerCase();

interface Props {
    callback
}

interface State {
    MyFormList;
    AllFormList;
    TemplateList;
    activeIndex: number,
    isBusy: boolean,
    confirmVisible: boolean,
    formToDelete?: any,
    myPaging: PagingState,
    allPaging: PagingState,
    templatePaging: PagingState,
}

interface PagingState {
    page: number;
    rows: number;
    first: number;
    totalRecords: number;
}

export class ListFormComponent extends React.Component<Props, State> {
    private readonly deleteDisabledByEnv = ENVIRONMENT === 'prod' || ENVIRONMENT === 'production';

    normalizeList = (data: any): { list: any[]; totalRecords: number } => {
        const payload = data?.data ?? data;

        if (Array.isArray(payload)) {
            return { list: payload, totalRecords: payload.length };
        }

        const content = payload?.content ?? payload?.data?.content;
        const total = payload?.totalElements ?? payload?.data?.totalElements ?? (Array.isArray(content) ? content.length : 0);

        if (Array.isArray(content)) {
            return { list: content, totalRecords: total };
        }

        return { list: [], totalRecords: 0 };
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            MyFormList: [],
            AllFormList: [],
            TemplateList: [],
            activeIndex: 0,
            isBusy: false,
            confirmVisible: false,
            formToDelete: null,
            myPaging: { page: 0, rows: 10, first: 0, totalRecords: 0 },
            allPaging: { page: 0, rows: 10, first: 0, totalRecords: 0 },
            templatePaging: { page: 0, rows: 10, first: 0, totalRecords: 0 },
        };
    }

    private fetchAllPaged = async (api: string, headers: any, pageSize = 50) => {
        const firstResponse = await axios.get(api, { headers, params: { page: 0, size: pageSize } });
        const firstNormalized = this.normalizeList(firstResponse.data);
        const payload = firstResponse.data?.data ?? firstResponse.data;
        const totalPages = payload?.totalPages ?? 1;

        if (totalPages <= 1) {
            return firstNormalized;
        }

        const requests = [];
        for (let page = 1; page < totalPages; page++) {
            requests.push(axios.get(api, { headers, params: { page, size: pageSize } }));
        }
        const responses = await Promise.all(requests);
        const additionalItems = responses.flatMap(r => this.normalizeList(r.data).list);
        return { list: [...firstNormalized.list, ...additionalItems], totalRecords: firstNormalized.totalRecords };
    }

    getlist = async () => {
        let api = URLUtils.concatUrls('data/admin/my-form');
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }
        this.setState({ isBusy: true })
        try {
            const { list, totalRecords } = await this.fetchAllPaged(api, headers);
            this.setState({
                isBusy: false,
                MyFormList: list,
                myPaging: { ...this.state.myPaging, totalRecords, page: 0, first: 0 }
            });
        } catch (ex) {
            console.log(ex);
            this.setState({ isBusy: false });
        }
    }
    componentDidMount = () => {
        this.getlist();

    }

    userIsCoOwner = (attachment: string, categoryId: string) => {
        let myUserId = SessionStorageService.getUserId().toLowerCase();
        let usersList = parseJson(attachment, categoryId).Coowners;
        if (usersList == null) { return false }
        return usersList.find((user) => user.email.toLowerCase() == myUserId)
    }
    setActiveIndex = (index) => {

        this.setState({ activeIndex: index })
        switch (index) {
            case 0: {
                // let api = URLUtils.concatUrls('data/admin/all-form');
                // const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                // const headers = {
                //     'Authorization': `Bearer ${token}`
                // }
                // this.setState({isBusy:true})
                // axios.get(api, {headers:headers}).then(
                //     (response) => {
                //         console.log(response.data);
                //         let myUserId = SessionStorageService.getUserId().toLowerCase();
                //         console.log(myUserId);
                //         console.log(response.data)
                //         let myFormList = response.data.filter((form) => form.createdById.toLowerCase()==myUserId || this.userIsCoOwner(form.attachment, form.categoryId));
                //         this.setState({ MyFormList: myFormList, isBusy:false });
                //     }
                // )
                this.getlist();
            }
            case 1: {
                this.loadAllForms();
                break;
            }
            case 2: {
                this.loadTemplates();
            }
        }
    }

    loadAllForms = async () => {
        let api = URLUtils.concatUrls('data/admin/all-form');
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }
        this.setState({ isBusy: true })
        try {
            const { list, totalRecords } = await this.fetchAllPaged(api, headers);
            this.setState({
                AllFormList: list,
                isBusy: false,
                allPaging: { ...this.state.allPaging, totalRecords, page: 0, first: 0 }
            });
        } catch (ex) {
            console.log(ex);
            this.setState({ isBusy: false });
        }
    }

    loadTemplates = async () => {
        let api = URLUtils.concatUrls('data/admin/all-template');
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }
        this.setState({ isBusy: true })
        try {
            const { list, totalRecords } = await this.fetchAllPaged(api, headers);
            this.setState({
                TemplateList: list,
                isBusy: false,
                templatePaging: { ...this.state.templatePaging, totalRecords, page: 0, first: 0 }
            });
        } catch (ex) {
            console.log(ex);
            this.setState({ isBusy: false });
        }
    }

    inputTemplate = (rowData) => {
        return (new Date(rowData.createdDate)).toLocaleString();
    }
    inputTemplateUpdate = (rowData) => {
        return (new Date(rowData.updatedDate)).toLocaleString();
    }
    inputTemplateFilter = (value, filter) => {
        if (filter === undefined || filter === null || filter === '') {
            return true;
        }
        
        if (value === undefined || value === null) {
            return false;
        }
        
        const dateValue = new Date(value);
        const filterDate = new Date(filter);
        
        // Compare dates (ignoring time)
        return dateValue.toDateString() === filterDate.toDateString();
    }

    isOwner = (rowData) => {
        const myUserId = SessionStorageService.getUserId()?.toLowerCase();
        const createdBy = rowData?.createdById || rowData?.createdByID || rowData?.userId;
        if (!myUserId || !createdBy) return false;
        return myUserId === String(createdBy).toLowerCase();
    }

    parseFlag = (value: any) => {
        if (value === undefined || value === null) return false;
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value === 1;
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            return normalized === 'true' || normalized === 'y' || normalized === 'yes' || normalized === '1';
        }
        return false;
    }

    isDeployed = (rowData) => {
        const candidates = [
            rowData?.deployed,
            rowData?.Deployed,
            rowData?.alreadyDeployed,
            rowData?.AlreadyDeployed,
            rowData?.alreadyDeployedToProduction,
            rowData?.AlreadyDeployedToProduction,
            rowData?.deployedToProduction,
            rowData?.DeployedToProduction,
        ];
        let isFlagged = candidates.some(v => this.parseFlag(v));

        // Fallback: check serialized attachment if present
        if (!isFlagged && typeof rowData?.attachment === 'string') {
            try {
                const parsed = parseJson(rowData.attachment, rowData.categoryId);
                const attachmentFlags = [
                    parsed?.Deployed,
                    parsed?.deployed,
                    parsed?.AlreadyDeployedToProduction,
                    parsed?.alreadyDeployedToProduction,
                    parsed?.deployedToProduction,
                    parsed?.DeployedToProduction,
                ];
                isFlagged = attachmentFlags.some(v => this.parseFlag(v));
            } catch (err) {
                console.log('Failed to parse attachment for deployed flag', err);
            }
        }

        return isFlagged;
    }

    deleteButtonTemplate = (rowData) => {
        const disabled = this.deleteDisabledByEnv || !this.isOwner(rowData) || this.isDeployed(rowData);
        return (
            <Button
                label="Delete"
                className="p-button-danger"
                disabled={disabled}
                onClick={(e) => {
                    e.stopPropagation();
                    this.setState({ confirmVisible: true, formToDelete: rowData });
                }}
            />
        );
    }

    deleteForm = async () => {
        const { formToDelete } = this.state;
        if (!formToDelete) {
            this.setState({ confirmVisible: false });
            return;
        }

        const formId = formToDelete.id || formToDelete.categoryId;
        if (!formId) {
            this.setState({ confirmVisible: false, formToDelete: null });
            return;
        }

        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        };

        try {
            this.setState({ isBusy: true, confirmVisible: false });
            const api = URLUtils.concatUrls(`data/admin/form/${formId}`);
            await axios.delete(api, { headers });
            this.setState({ formToDelete: null });
            this.getlist();
        } catch (ex) {
            console.log(ex);
            this.setState({ isBusy: false, confirmVisible: false, formToDelete: null });
        }
    }

    render() {
        let addButton = <Button
            key={'BtnAdd_'}
            label={"Create New Form"}
            onClick={(e) => {
                this.props.callback()
            }}
        />;

        let header = (
            <div key={'fdHeader_div_'} style={{ textAlign: 'center' }} >
                {addButton}
            </div>
        );

        return (
            <>
                <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setActiveIndex(e.index)}>
                    <TabPanel header="My Forms">
                        <DataTable 
                            resizableColumns 
                            value={Array.isArray(this.state.MyFormList) ? this.state.MyFormList : []} 
                            header={header} showGridlines 
                            selectionMode="single" 
                            key="id" 
                            filterDisplay="row" 
                            globalFilterFields={['categoryId', 'categoryName', 'userName', 'userUpdateName', 'createdDate', 'updatedDate']} 
                            onSelectionChange={e => this.props.callback(e.value)} 
                            paginator rows={this.state.myPaging.rows} rowsPerPageOptions={[10, 20, 50]} 
                            first={this.state.myPaging.first}
                            onPage={(e) => this.setState({ myPaging: { ...this.state.myPaging, rows: e.rows, page: e.page, first: e.first } })}
                        >
                            <Column field="categoryId" header="Application ID" filter style={{overflowX: 'auto'}}></Column>
                            <Column field="categoryName" header="Application Name" filter style={{overflowX: 'auto'}}></Column>
                            <Column 
                                field="createdDate"
                                body={this.inputTemplate} 
                                header="Created On" 
                                filter 
                                filterField="createdDate"
                                filterMatchMode="custom"
                                filterFunction={this.inputTemplateFilter}
                                style={{overflowX: 'auto'}}
                            ></Column>
                            <Column field="userName" header="Created By" filter style={{overflowX: 'auto'}}></Column>
                            <Column 
                                field="updatedDate"
                                body={this.inputTemplateUpdate} 
                                header="Updated On" 
                                filter 
                                filterField="updatedDate"
                                filterMatchMode="custom"
                                filterFunction={this.inputTemplateFilter}
                                style={{overflowX: 'auto'}}
                            ></Column>
                            <Column field="userUpdateName" header="Updated By" filter style={{overflowX: 'auto'}}></Column>
                            <Column body={this.deleteButtonTemplate} header="Delete" style={{ minWidth: '8rem' }}></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="All Forms">
                        <DataTable 
                            value={Array.isArray(this.state.AllFormList) ? this.state.AllFormList : []} 
                            showGridlines 
                            selectionMode="single" 
                            filterDisplay="row" 
                            globalFilterFields={['categoryId', 'categoryName', 'userName', 'userUpdateName', 'createdDate', 'updatedDate']} 
                            onSelectionChange={e => this.props.callback(e.value)}
                            paginator rows={this.state.allPaging.rows} rowsPerPageOptions={[10, 20, 50]} 
                            first={this.state.allPaging.first}
                            onPage={(e) => this.setState({ allPaging: { ...this.state.allPaging, rows: e.rows, page: e.page, first: e.first } })} 
                        >
                            <Column field="categoryId" header="Application ID" filter style={{overflowX: 'auto'}}></Column>
                            <Column field="categoryName" header="Application Name" filter style={{overflowX: 'auto'}}></Column>
                            {/* <Column field="reportbackType" style={{ width: '20%' }} header="Report Back Type"></Column>
                            <Column field="reportbackName" style={{ width: '20%' }} header="Report Back Name"></Column> */}
                            <Column 
                                field="createdDate"
                                body={this.inputTemplate} 
                                header="Created On" 
                                filter 
                                filterField="createdDate"
                                filterMatchMode="custom"
                                filterFunction={this.inputTemplateFilter}
                                style={{overflowX: 'auto'}}
                            ></Column>
                            <Column field="userName" header="Created By" filter style={{overflowX: 'auto'}}></Column>
                            <Column 
                                field="updatedDate"
                                body={this.inputTemplateUpdate} 
                                header="Updated On" 
                                filter 
                                filterField="updatedDate"
                                filterMatchMode="custom"
                                filterFunction={this.inputTemplateFilter}
                                style={{overflowX: 'auto'}}
                            ></Column>
                            <Column field="userUpdateName" header="Updated By" filter style={{overflowX: 'auto'}}></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="All Templates">
                        <DataTable 
                            value={Array.isArray(this.state.TemplateList) ? this.state.TemplateList : []} 
                            showGridlines filterDisplay="row" 
                            globalFilterFields={['id', 'categoryName', 'userName', 'userUpdateName', 'createdDate', 'updatedDate']}
                            paginator rows={this.state.templatePaging.rows} rowsPerPageOptions={[10, 20, 50]} 
                            first={this.state.templatePaging.first}
                            onPage={(e) => this.setState({ templatePaging: { ...this.state.templatePaging, rows: e.rows, page: e.page, first: e.first } })}
                        >
                            <Column field="id"header="ID" filter style={{overflowX: 'auto'}}></Column>
                            <Column field="categoryName"header="Template Name" filter style={{overflowX: 'auto'}}></Column>
                            <Column 
                                field="createdDate"
                                body={this.inputTemplate} 
                                header="Created On" 
                                filter 
                                filterField="createdDate"
                                filterMatchMode="custom"
                                filterFunction={this.inputTemplateFilter}
                                style={{overflowX: 'auto'}}
                            ></Column>
                            <Column field="userName" header="Created By" filter style={{overflowX: 'auto'}}></Column>
                            <Column 
                                field="updatedDate"
                                body={this.inputTemplateUpdate} 
                                header="Updated On" 
                                filter 
                                filterField="updatedDate"
                                filterMatchMode="custom"
                                filterFunction={this.inputTemplateFilter}
                                style={{overflowX: 'auto'}}
                            ></Column>
                            <Column field="userUpdateName" header="Updated By" filter style={{overflowX: 'auto'}}></Column>
                        </DataTable>
                    </TabPanel>
                </TabView>
                <div>
                    <SpinnerComponent isBusy={this.state.isBusy} />
                </div>
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false, formToDelete: null })}
                    message={`Are you sure you want to delete "${this.state.formToDelete?.categoryName || this.state.formToDelete?.categoryId || 'this form'}"?`}
                    header="Confirm Delete"
                    accept={this.deleteForm}
                    reject={() => this.setState({ confirmVisible: false, formToDelete: null })}
                />
            </>

        )
    }

}
